import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelCatInTheBoxDefault: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props}>
    <path
      opacity="0.5"
      d="M112.485 160.691L151.802 153.122L150.961 149.338L151.592 145.132L77.3727 108.338L26.9122 118.22L112.485 160.691Z"
      fill="url(#paint0_linear)"
    />
    <path d="M110.382 143.24L133.51 138.825L87.0443 115.697L64.1269 120.113L110.382 143.24Z" fill="#996A0D" />
    <path d="M133.51 65.4471L215.088 50.9397L168.622 27.812L87.0443 42.5296L133.51 65.4471Z" fill="#FDDE84" />
    <path d="M133.51 65.447L152.222 54.5139L105.967 31.3862L87.0443 42.5296L133.51 65.447Z" fill="#996A0D" />
    <path d="M133.51 65.447V138.825L87.0443 115.697V42.5295L133.51 65.447Z" fill="#634509" />
    <path d="M65.3884 38.9553V111.282L87.0443 115.697V42.5296L65.3884 38.9553Z" fill="#C39000" />
    <path
      opacity="0.5"
      d="M106.177 144.292L133.51 138.825V106.026L59.7115 121.164L106.177 144.292Z"
      fill="url(#paint1_linear)"
    />
    <path d="M128.254 129.574L79.6855 120.743L107.439 107.077L156.007 115.697L128.254 129.574Z" fill="#926608" />
    <path
      opacity="0.3"
      d="M127.413 134.83L101.972 132.097L108.49 126.42L117.951 123.687L158.109 124.528L127.413 134.83Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M75.901 124.528C74.8497 127.051 78.2137 130.835 83.47 132.938C88.7263 135.04 93.7724 134.62 94.8236 132.097C95.8749 129.574 92.5109 125.789 87.2546 123.687C84.5213 122.635 83.2598 120.323 81.1573 120.533C78.8445 121.164 76.9522 122.635 75.901 124.528Z"
      fill="#C9CAC9"
    />
    <path
      d="M145.915 84.5799C142.13 82.0569 137.715 80.7954 133.3 80.7954C129.305 80.7954 125.52 81.6364 122.156 83.5287C119.213 85.2107 115.428 88.1542 108.7 86.4722L102.603 127.051L118.372 128.943C118.372 128.943 143.812 131.887 152.222 127.051C152.222 127.051 161.263 116.748 156.217 98.2463C156.007 98.4566 154.535 91.5183 145.915 84.5799Z"
      fill="#C9CAC9"
    />
    <path
      d="M86.2033 90.6773L80.5265 84.1595C80.5265 84.1595 78.424 82.4775 78.2137 85.6313L78.8445 97.4054"
      fill="#E5E5E5"
    />
    <path
      d="M84.311 90.2566L81.1573 86.6823C81.1573 86.6823 80.106 85.6311 79.8958 87.5233L80.3163 94.0411"
      fill="#C9C9C9"
    />
    <path d="M80.5265 86.262C80.106 86.262 79.8957 86.262 79.6855 87.3132L80.106 93.831" fill="#B8B9B8" />
    <path
      d="M152.012 127.261C152.012 127.261 147.597 122.636 143.182 122.005C138.766 121.374 134.141 124.528 131.618 124.107C123.418 122.846 117.741 113.595 117.741 113.595C117.741 113.595 113.326 119.272 108.7 125.369C104.075 131.466 106.177 127.051 106.177 127.051L95.0339 124.107L97.9774 127.471C97.9774 127.471 105.967 128.943 107.018 128.943C108.069 128.943 122.367 129.574 122.997 129.574C123.628 129.574 144.864 131.676 152.012 127.261Z"
      fill="#B8B9B8"
    />
    <path
      d="M110.63 134.526C116.23 133.522 120.372 130.484 119.88 127.741C119.388 124.998 114.45 123.588 108.849 124.592C103.249 125.596 99.1072 128.633 99.5988 131.376C100.09 134.119 105.029 135.529 110.63 134.526Z"
      fill="#C9CAC9"
    />
    <path
      d="M100.29 129.784C100.711 131.045 102.603 131.466 104.705 130.835C106.808 130.204 111.434 125.158 111.434 124.317H111.013C108.28 124.528 105.757 125.369 103.234 126.42C102.393 126.84 101.762 127.261 101.131 127.892C100.5 128.522 100.08 129.153 100.29 129.784Z"
      fill="#B8B9B8"
    />
    <path
      d="M93.9826 128.102C93.5621 129.364 91.4596 129.364 89.3571 128.733C87.2546 128.102 79.4752 121.584 79.8957 120.323C80.3163 119.061 88.7263 123.897 90.8289 124.528C92.9314 125.159 94.4031 127.051 93.9826 128.102Z"
      fill="#B8B9B8"
    />
    <path
      d="M96.9261 128.523C109.699 128.523 120.054 118.545 120.054 106.236C120.054 93.9273 109.699 83.9492 96.9261 83.9492C84.1531 83.9492 73.7984 93.9273 73.7984 106.236C73.7984 118.545 84.1531 128.523 96.9261 128.523Z"
      fill="#E5E5E5"
    />
    <path
      d="M79.6855 111.072L79.4753 110.651C82.4188 109.81 85.5726 110.02 88.5161 111.072V111.282V111.492C85.5726 111.492 82.629 112.123 80.106 113.595L79.8958 113.174C82.2085 111.913 84.7315 111.282 87.2546 111.072C84.7315 110.441 82.2085 110.441 79.6855 111.072Z"
      fill="#C9C9C9"
    />
    <path
      d="M95.4544 111.492C98.8184 110.231 102.393 110.231 105.546 111.492L105.336 111.913C102.603 110.861 99.6594 110.651 96.7159 111.492C99.4492 111.702 101.972 112.543 104.285 113.805L104.075 114.225C101.341 112.754 98.3979 111.913 95.4544 111.913V111.492Z"
      fill="#C9C9C9"
    />
    <path d="M110.593 94.0411V85.0003C109.962 81.6362 107.229 83.7388 107.229 83.7388L102.182 88.9951" fill="#E5E5E5" />
    <path d="M102.603 90.2569L106.598 86.0518C106.598 86.0518 108.28 84.7903 108.7 86.8928V92.9902" fill="#C9C9C9" />
    <path
      d="M105.126 91.5181L102.603 90.4668L106.598 86.2618C107.018 86.0516 107.439 85.8413 107.859 85.8413C107.439 86.2618 107.018 86.4721 106.598 87.1028C106.387 87.5233 105.967 88.1541 105.967 88.5746L105.336 90.6771L105.126 91.5181Z"
      fill="#B8B9B8"
    />
    <path
      d="M101.341 106.656C102.154 106.656 102.813 105.997 102.813 105.185C102.813 104.372 102.154 103.713 101.341 103.713C100.529 103.713 99.8697 104.372 99.8697 105.185C99.8697 105.997 100.529 106.656 101.341 106.656Z"
      fill="black"
    />
    <path
      d="M84.7315 106.656C85.5444 106.656 86.2033 105.997 86.2033 105.185C86.2033 104.372 85.5444 103.713 84.7315 103.713C83.9187 103.713 83.2598 104.372 83.2598 105.185C83.2598 105.997 83.9187 106.656 84.7315 106.656Z"
      fill="black"
    />
    <path
      d="M143.602 83.3183C143.812 83.3183 160.632 93.4104 146.966 97.8257C133.3 102.241 126.151 81.8466 126.151 81.8466C126.151 81.8466 135.823 78.6928 143.602 83.3183Z"
      fill="#B8B9B8"
    />
    <path
      d="M133.089 117.379C137.154 117.379 140.448 114.838 140.448 111.702C140.448 108.567 137.154 106.026 133.089 106.026C129.025 106.026 125.731 108.567 125.731 111.702C125.731 114.838 129.025 117.379 133.089 117.379Z"
      fill="#B8B9B8"
    />
    <path
      d="M89.2244 97.867C93.6518 95.5582 96.0657 91.4329 94.616 88.6529C93.1662 85.8729 88.4019 85.4909 83.9745 87.7997C79.5471 90.1086 77.1332 94.2339 78.583 97.0138C80.0327 99.7938 84.797 100.176 89.2244 97.867Z"
      fill="#C9C9C9"
    />
    <path d="M92.0904 112.543L89.3571 109.39H95.2441L92.0904 112.543Z" fill="#D20612" />
    <path d="M133.51 65.4471V138.825L215.088 124.107V50.9397L133.51 65.4471Z" fill="#FCCE09" />
    <path d="M133.51 65.447V138.825L152.012 153.753V79.5339L133.51 65.447Z" fill="#FDDE84" />
    <path
      d="M90.4084 114.015C90.4084 114.015 90.4084 116.118 92.0904 116.328C92.0904 116.328 93.7724 116.538 93.7724 114.225C93.7724 114.225 92.0904 113.174 91.8801 112.543C91.4596 113.174 91.0391 113.595 90.4084 114.015Z"
      fill="#E5E5E5"
    />
    <path
      d="M85.152 112.123C85.3623 112.123 85.5725 112.123 85.5725 112.333C85.993 113.385 87.0443 114.015 88.0956 114.226C89.5673 114.646 91.0391 113.805 91.8801 112.544H92.0903C92.7211 113.595 93.7724 114.436 94.8236 114.436C96.5056 114.856 98.1876 114.226 99.0287 112.754C99.2389 112.544 99.4492 112.544 99.4492 112.754C99.6594 112.964 99.6594 112.964 99.4492 113.174C98.6082 114.436 97.3466 115.277 95.6646 115.277C95.2441 115.277 95.0339 115.277 94.6134 115.277C93.3519 115.067 92.3006 114.436 91.6698 113.385C91.0391 114.436 89.7776 115.067 88.5161 115.067C88.3058 115.067 87.8853 115.067 87.4648 115.067C86.2033 114.856 84.9418 114.015 84.5213 112.754C84.311 112.544 84.311 112.333 84.5213 112.123C84.7315 111.913 84.9418 111.913 85.152 112.123Z"
      fill="#8E8E8E"
    />
    <path
      d="M192.381 114.646C193.011 112.964 191.75 110.861 190.278 111.072C189.227 111.492 188.596 112.754 189.016 113.805C189.437 115.697 191.75 116.328 192.381 114.646Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M198.057 112.333C197.216 112.543 196.796 113.595 197.006 114.436C197.427 116.118 199.109 116.328 199.739 115.066C200.37 113.805 199.319 111.913 198.057 112.333Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M196.375 113.595C197.006 111.913 195.745 109.81 194.273 110.02C193.222 110.441 192.591 111.702 193.011 112.754C193.432 114.856 195.534 115.277 196.375 113.595Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M193.642 115.697C191.96 115.908 190.488 117.169 189.858 118.851C189.437 120.743 190.699 122.846 192.381 122.215C193.642 121.795 193.852 121.164 194.904 120.954C195.955 120.743 196.375 121.164 197.637 120.954C199.529 120.533 199.739 118.22 198.268 116.749C197.216 115.277 195.324 114.856 193.642 115.697Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M189.647 117.379C190.278 116.118 189.227 114.436 187.965 114.646C187.124 115.067 186.704 115.908 186.914 116.749C187.335 118.22 189.017 118.641 189.647 117.379Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M190.278 83.739C190.909 82.057 189.647 79.9545 187.965 80.1647C186.914 80.5853 186.283 81.8468 186.704 82.898C187.545 85.0005 189.647 85.4211 190.278 83.739Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M195.955 81.4261C195.114 81.8466 194.693 82.6877 195.114 83.5287C195.534 85.2107 197.216 85.4209 197.847 84.1594C198.478 82.8979 197.216 81.2159 195.955 81.4261Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M194.273 82.6878C194.904 81.0058 193.642 78.9032 191.96 79.1135C190.909 79.534 190.278 80.7955 190.699 81.8468C191.54 83.9493 193.642 84.5801 194.273 82.6878Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M191.54 84.7903C189.858 85.0005 188.386 86.262 187.755 87.944C187.335 89.8363 188.596 91.9388 190.488 91.308C191.75 90.8875 191.96 90.2568 193.011 89.8363C194.063 89.4158 194.483 90.0465 195.745 89.8363C197.637 89.4158 197.637 87.103 196.375 85.6313C195.114 84.58 193.222 84.1595 191.54 84.7903Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M187.755 86.6826C188.386 85.4211 187.335 83.7391 186.073 83.9493C185.232 84.3698 184.811 85.2108 185.232 86.0519C185.442 87.5236 187.124 87.9441 187.755 86.6826Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M203.314 98.6669C204.575 97.4054 204.155 94.8823 202.683 94.6721C201.632 94.4618 200.791 95.5131 200.58 96.5644C200.16 98.6669 202.052 99.9284 203.314 98.6669Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M209.621 98.8772C208.78 98.6669 207.939 99.5079 207.939 100.349C207.729 102.031 209.201 102.872 210.252 102.031C211.303 101.19 210.883 99.0874 209.621 98.8772Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M207.519 99.2976C208.78 98.0361 208.36 95.5131 206.888 95.3028C205.837 95.0926 204.996 96.1438 204.785 97.4053C204.365 99.2976 206.047 100.559 207.519 99.2976Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M204.155 100.139C202.473 99.7182 200.58 100.139 199.529 101.61C198.478 103.082 198.688 105.605 200.58 105.815C201.842 105.815 202.262 105.395 203.314 105.395C204.365 105.395 204.575 106.236 205.837 106.656C207.729 107.077 208.78 104.974 208.149 103.082C207.519 101.4 205.837 100.139 204.155 100.139Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M199.95 100.139C201.001 99.0874 200.58 97.1951 199.319 96.9849C198.478 96.9849 197.637 97.6156 197.637 98.6669C197.216 100.139 198.898 101.19 199.95 100.139Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M102.182 96.1438C103.444 96.3541 104.495 96.9848 105.336 98.0361"
      stroke="black"
      strokeWidth="0.4"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M102.182 96.1438C103.444 96.3541 104.495 96.9848 105.336 98.0361"
      stroke="black"
      strokeWidth="0.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M84.5213 96.354C83.2598 96.5643 82.2085 97.195 81.3675 98.036"
      stroke="black"
      strokeWidth="0.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="81.8094"
        y1="158.967"
        x2="98.7978"
        y2="105.921"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.93" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="92.5561"
        y1="137.89"
        x2="113.849"
        y2="96.1028"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.93" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="134.343"
        y1="136.776"
        x2="124.841"
        y2="118.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.93" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
